"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.SaveStringButton = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var React = _interopRequireWildcard(require("react"));

var canUseMSSaveBlobFunction = window.navigator && window.navigator.msSaveBlob !== undefined;

var onMsSave = function onMsSave(stringToSave, fileName) {
  var blob = new Blob([stringToSave], {
    type: 'text/plain'
  });
  window.navigator.msSaveBlob(blob, fileName);
};

var getBrowserSpecificProps = function getBrowserSpecificProps(stringToSave, fileName) {
  if (canUseMSSaveBlobFunction) {
    return {
      onClick: function onClick() {
        onMsSave(stringToSave, fileName);
      }
    };
  } else {
    return {
      download: fileName,
      href: "data:text/plain;base64,".concat(btoa(stringToSave)),
      target: '_blank'
    };
  }
};

var SaveStringButton = function SaveStringButton(_ref) {
  var fileName = _ref.fileName,
      buttonProps = _ref.buttonProps,
      stringToSave = _ref.stringToSave;
  var memoizedGetBrowserSpecificProps = (0, React.useMemo)(function () {
    return getBrowserSpecificProps(stringToSave, fileName);
  }, [stringToSave, fileName]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Button, (0, _objectSpread2.default)((0, _objectSpread2.default)({
    iconProps: {
      iconName: 'Download'
    }
  }, memoizedGetBrowserSpecificProps), buttonProps));
};

exports.SaveStringButton = SaveStringButton;